import { render } from "./RequestToTeamSuccess.vue?vue&type=template&id=3cfe41f1&scoped=true"
const script = {}

import "./RequestToTeamSuccess.vue?vue&type=style&index=0&id=3cfe41f1&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cfe41f1"]])

export default __exports__